interface PlayButtonProps {
  className?: string;
}

function PlayButton({ className = "" }: PlayButtonProps) {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="41" height="40" rx="20" fill="white" />
      <path
        d="M20.5001 3.3335C11.0701 3.3335 3.41675 10.8002 3.41675 20.0002C3.41675 29.2002 11.0701 36.6668 20.5001 36.6668C29.9301 36.6668 37.5834 29.2002 37.5834 20.0002C37.5834 10.8002 29.9301 3.3335 20.5001 3.3335ZM17.0834 27.5002V12.5002L27.3334 20.0002L17.0834 27.5002Z"
        fill="url(#paint0_linear_play)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_play"
          x1="20.5001"
          y1="3.3335"
          x2="20.5001"
          y2="36.6668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B775FF" />
          <stop offset="1" stopColor="#8139D0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PlayButton;
